import React from 'react';
import { Routes, Route } from 'react-router-dom';

import ConsultsList from 'features/consults/components/ConsultsList/ConsultsList';
import ConsultDetailsWrapper from 'features/consults/components/ConsultDetailsWrapper/ConsultDetailsWrapper';
import { ServiceTypeEnum } from 'utils/enums';

const EegConsults = () => (
  <Routes>
    <Route
      path="/"
      element={<ConsultsList consultType={ServiceTypeEnum.EEG} />}
    />
    <Route
      path="/:consultId"
      element={<ConsultDetailsWrapper consultType={ServiceTypeEnum.EEG} />}
    />
  </Routes>
);

export default EegConsults;
